export default class Constants {
	static readonly STORAGE_HEADQUARTER: string = 'APICIHeadquarter';
	static readonly DEFAULT_HEADQUARTER_NEWPERCENTAGE: number = 30;
	static readonly DEFAULT_HEADQUARTER_DORMIENTPERCENTAGE: number = 20;
	static readonly DEFAULT_HEADQUARTER_PORTFOLIOPERCENTAGE: number = 10;
}